import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconBathtub: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21 12H7V5c0-.6.4-1 1-1h3c.6 0 1 .4 1 1v.1c-1.7.5-3 2-3 3.9 0 .6.4 1 1 1h6c.6 0 1-.4 1-1 0-1.9-1.3-3.4-3-3.9V5c0-1.7-1.3-3-3-3H8C6.3 2 5 3.3 5 5v7H3c-.6 0-1 .4-1 1s.4 1 1 1h1v2c0 1.5.8 2.7 2 3.4V21c0 .6.4 1 1 1s1-.4 1-1v-1h8v1c0 .6.4 1 1 1s1-.4 1-1v-1.6c1.2-.7 2-2 2-3.4v-2h1c.6 0 1-.4 1-1s-.4-1-1-1zm-6.3-4h-3.4c.3-.6 1-1 1.7-1s1.4.4 1.7 1zm3.3 8c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2v-2h12v2z',
    })
  )
}
